<app-background [backgroundImage]="'images/shared/backgrounds/default.png'">
    @if (projectData) {
      <h1 class="sr-only">{{ projectData.name }} — {{ type === 'development' ? 'Mobile App Development' : 'App Marketing' }} Case Study</h1>
    }
    <app-hero-section height="620px" paddingTop="520px" opacity='.7'
        [backgroundImage]="projectData?.background || `images/${file}/backgrounds/${file}.png`"
        [projectName]="projectData?.name || ''" [text]="type ?? ''">
    </app-hero-section>
</app-background>

<app-background backgroundImage="images/shared/backgrounds/background-2.avif">
    <app-project-details [project]="projectData!"></app-project-details>
    <div class="mt-[100px] pb-[168px]">
        <app-card-container [cards]="getProjectCards()"></app-card-container>
    </div>
     <div class="mpb-[50px]">
        <app-download-info [downloadLinks]="projectData?.downloadLinks"></app-download-info>
    </div>
</app-background>

<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <div class="pt-[200px]">
        <app-info-card>
            <div class="flex flex-col justify-center items-center">
                <div class="font-outfit text-xl sm:text-3xl font-semibold mb-2 sm:mb-6">
                    {{ type }} <span class="gradient-text">case studies</span>
                </div>
                <div class="font-inter mb-6 sm:mb-[21px] text-center text-sm sm:text-base">
                    See the <b>SEM Nexus</b> process in action. Join us and take a deep dive into our best development
                    work.
                </div>
                <app-button buttonText="see all case studies" (clicked)="goToCaseStudies()"></app-button>
            </div>
        </app-info-card>
    </div>
    <app-connect></app-connect>
</app-background>